import { FC } from 'react';
import { useTranslation } from '../../../utils/useTranslation';
import { Dialog, DialogContent, DialogFooter, DialogTitle } from '../../feedback/Dialog';
import { useDialogScroll } from '../../feedback/hooks/useDialogScroll';
import { DataTestId } from '../../layout/DataTestIdWrapper';
import { Typography } from '../../typography/Typography';
import { CollectionInfoContent } from '../CollectionInfoContent/CollectionInfoContent';
import { ActionButton } from '../styles';
import { EditCollectionDrawerProps } from './types';

export const EditCollectionDrawer: FC<EditCollectionDrawerProps> = ({
    values,
    handlers,
    submitDisabled,
    onClose,
}) => {
    const t = useTranslation();

    const { modalContentRef, atTop, atBottom } = useDialogScroll();

    const title = t('Редактировать коллекцию');

    return (
        <Dialog onClose={onClose} dataTestId={DataTestId.EDIT_COLLECTION_DRAWER}>
            <DialogTitle onClose={onClose} withBorderBottom={!atTop}>
                <Typography variant="title3" weight="bold">
                    {title}
                </Typography>
            </DialogTitle>
            <DialogContent ref={modalContentRef} py={0} px={0}>
                <CollectionInfoContent values={values} handlers={handlers} />
            </DialogContent>
            <DialogFooter withBorderTop={!atBottom}>
                <ActionButton
                    dataTestId={DataTestId.EDIT_COLLECTION_SUBMIT_BUTTON}
                    minHeight="46px"
                    onClick={handlers.onSubmit}
                    disabled={submitDisabled}
                >
                    {t('Сохранить')}
                </ActionButton>
            </DialogFooter>
        </Dialog>
    );
};
